import React, { useState, useRef, useEffect } from 'react';
import { Field, submit } from 'redux-form';
import { Input } from '../../../../../../../itrust_common/components/form';
import { orderUpdate } from '../../../../../../../redux/actions/order/orderActions';
import { useDispatch } from 'react-redux';

const PrismField = ({ input, label, eyeTitle, wrapperClasses, className }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch()
    const rawValue = input.value;

    const isObject =
    rawValue && typeof rawValue === 'object' && !Array.isArray(rawValue);

    const isLegacyValue =
    rawValue !== null &&
    rawValue !== undefined &&
    !isObject &&
    rawValue !== '';

    const value = isObject ? rawValue : {};

    const horizontal = value.horizontal || { value: '', direction: '' };
    const vertical = value.vertical || { value: '', direction: '' };
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggle = () => setIsOpen(!isOpen);

    const handleChange = (type, field, val) => {
    const newValue = {
        horizontal: { ...horizontal },
        vertical: { ...vertical },
    };

    newValue[type][field] = val;

    input.onChange(newValue);
    };

    const handleClear = () => {
        input.onChange(null);
        setIsOpen(false);
    };
    const handleOrderSubmit = () => {
        setTimeout(() => dispatch(submit('orderEyeglassForm')), 500)
    }
    const hasH = horizontal.value || horizontal.direction;
    const hasV = vertical.value || vertical.direction;

    return (
        <div className={`form-group ${wrapperClasses || ''}`} ref={dropdownRef}>
            {label && <label className="w-100">{label}</label>}
            <div className="dropdown w-100 position-relative">
                <button
                    type="button"
                    className={`btn w-100 d-flex flex-column text-left px-2 py-1 prism-dropdown-toggle ${isOpen ? 'dropdown-open' : ''} ${className || ''}`}
                    onClick={toggle}
                >
                    <div className="w-100 d-flex justify-content-between align-items-center">
                       <span className="prism-dropdown-title">
                            {isLegacyValue ? rawValue : 'Prism'}
                       </span>
                        <i className={`las ${isOpen ? 'la-angle-up' : 'la-angle-down'}`}></i>
                    </div>
                    {!isLegacyValue && (hasH || hasV) && (
                    <div className="w-100 text-muted prism-dropdown-subtitle">
                        {hasH ? `H ${horizontal.value || ''} ${horizontal.direction || ''}` : ''}
                        {hasH && hasV ? ' - ' : ''}
                        {hasV ? `V ${vertical.value || ''} ${vertical.direction || ''}` : ''}
                    </div>
                    )}
                </button>

                {isOpen && (
                    <div className="dropdown-menu show p-3 shadow border prism-dropdown-menu">
                        <div className="d-flex justify-content-between mb-4 pb-2">
                            <h6 className="mb-0 font-weight-bold">{eyeTitle} Prism</h6>
                            <small className="text-muted">Value + direction</small>
                        </div>
                        <div className='nav-tabs-view'>

                            <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="prism-label-text">Horizontal</span>

                                    <input
                                        type="number"
                                        step="0.25"
                                        value={horizontal.value || ''}
                                        onChange={(e) =>
                                            handleChange('horizontal', 'value', e.target.value)
                                        }
                                        className="form-control prism-input-number mx-3"
                                    />

                                    <ul className="nav nav-pills prism-nav">
                                        <li className="nav-item nav-items">
                                            <button
                                                type="button"
                                                className={`nav-link ${horizontal.direction === 'IN' ? 'active' : ''}`}
                                                onClick={() => handleChange('horizontal', 'direction', 'IN')}
                                            >
                                                IN
                                            </button>
                                        </li>

                                        <li className="nav-item nav-items">
                                            <button
                                                type="button"
                                                className={`nav-link ${horizontal.direction === 'OUT' ? 'active' : ''}`}
                                                onClick={() => handleChange('horizontal', 'direction', 'OUT')}
                                            >
                                                OUT
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                {horizontal.value && !horizontal.direction && (
                                    <div className="text-danger small text-right mt-1">* Required</div>
                                )}
                            </div>
                            <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="prism-label-text">Vertical</span>

                                    <input
                                        type="number"
                                        step="0.25"
                                        value={vertical.value || ''}
                                        onChange={(e) =>
                                            handleChange('vertical', 'value', e.target.value)
                                        }
                                        className="form-control prism-input-number mx-3"
                                    />

                                    <ul className="nav nav-pills prism-nav">
                                        <li className="nav-item nav-items">
                                            <button
                                                type="button"
                                                className={`nav-link ${vertical.direction === 'UP' ? 'active' : ''}`}
                                                onClick={() => handleChange('vertical', 'direction', 'UP')}
                                            >
                                                UP
                                            </button>
                                        </li>

                                        <li className="nav-item nav-items">
                                            <button
                                                type="button"
                                                className={`nav-link ${vertical.direction === 'DOWN' ? 'active' : ''}`}
                                                onClick={() => handleChange('vertical', 'direction', 'DOWN')}
                                            >
                                                DOWN
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                                {vertical.value && !vertical.direction && (
                                    <div className="text-danger small text-right mt-1">* Required</div>
                                )}
                            </div>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                            <button type="button" className="btn btn-link text-muted p-0 prism-clear-btn" onClick={handleClear}>Clear prism</button>
                            <button type="button" className="btn btn-primary btn-sm px-4 prism-done-btn" onClick={() => {
                                if ((horizontal.value && !horizontal.direction) || (vertical.value && !vertical.direction)) {
                                    return;
                                }
                                setIsOpen(false)
                                handleOrderSubmit()
                            }}>Done</button>
                        </div>
                    </div>
                )}
            </div>
            {input.meta && input.meta.touched && input.meta.error && (
                <span className="invalid-feedback text-danger d-inline la-sm">{input.meta.error}</span>
            )}
        </div>
    );
}

export default PrismField;
